import { useTheme } from '@mui/material';
import { colors } from '@constants/colors';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      gap: 2,
      alignItems: 'center',
      color: colors.white,
      mb: 1.5,
    },
    avatar: {
      width: 64,
      height: 64,

      '& .MuiAvatar-root': {
        width: '100%',
        height: '100%',
      }
    },
    name: {
      width: 'calc(100% - 80px)',

      '& .MuiTypography-root': {
        fontFamily: 'Primary-Bold',
        fontSize: 20,
        lineHeight: '87%',
        overflow: 'hidden',

        '&:first-of-type': {
          display: 'inline-block',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
        },
      },
    },
  };
};
